export const isPickUpLessCurrentDate = (pickUpDate: Date) => {
  const clonePickUpDate = new Date(pickUpDate.getTime());
  const currentDate = new Date();

  clonePickUpDate.setSeconds(0, 0);
  currentDate.setSeconds(0, 0);

  return clonePickUpDate.getTime() < currentDate.getTime();
};
